import React, { useState, useRef, useEffect, useCallback } from "react";
import VideoPlayer from "../components/VideoPlayer";
import PortraitImg from "../assets/img/jbhifi.png";

const Portrait = () => {
  const [endpoint, setEndpoint] = useState(
    "https://ads-uncommonmedia.staging-adhese.com/e/stack/sl58"
  );
  const [videos, setVideos] = useState([]);
  const [eventLog, setEventLog] = useState([]);
  const loggedSet = useRef(new Set());
  const logEndRef = useRef(null);

  const CONFIG = {
    imageWidth: 1767,
    imageHeight: 1028,
    screenWidth: 260,
    screenHeight: 600,
    leftScreenPosition: { x: 148, y: 330 },
    rightScreenPosition: { x: 415 + 916, y: 330 },
    containerScale: 1,
  };

  const ENDPOINT_OPTIONS = [
    {
      label: "DOOH Portrait - Entrance DEMO - Apple",
      url: "https://ads-uncommonmedia.staging-adhese.com/e/stack/sl58",
    },
    {
      label: "DOOH Portrait - Telco Workstation DEMO - Apple",
      url: "https://ads-uncommonmedia.staging-adhese.com/e/stack/sl61",
    },
    {
      label: "DOOH Portrait - Entrance DEMO - Samsung",
      url: "https://ads-uncommonmedia.staging-adhese.com/e/stack/sl62",
    },
    {
      label: "DOOH Portrait - Telco Workstation DEMO - Samsung",
      url: "https://ads-uncommonmedia.staging-adhese.com/e/stack/sl64",
    },
  ];

  const fetchAds = useCallback(async () => {
    try {
      const res = await fetch(endpoint);
      const data = await res.json();
      const videoUrls = [];

      data.ads.forEach((ad, i) => {
        ad.assets.forEach((asset) => {
          if (asset.data?.type === 501 && asset.data.url.endsWith(".mp4")) {
            videoUrls.push({
              url: asset.data.url,
              trackers: ad.eventtrackers || [],
              adIndex: i,
            });
          }
        });
      });

      setVideos(videoUrls);
      setEventLog([]);
      loggedSet.current.clear();
    } catch (err) {
      console.error("Error fetching ads:", err);
      setVideos([]);
      setEventLog([]);
    }
  }, [endpoint]);

  const logEvent = (label, url) => {
    try {
      const key = `${label}:${url}`;
      if (!loggedSet.current.has(key)) {
        loggedSet.current.add(key);
        const time = new Date().toLocaleTimeString();
        const message = `[${time}] ${label}: ${url}`;
        setEventLog((prev) => [...prev, message]);
        console.log("Event Logged:", message);
      }
    } catch (err) {
      console.error("Error in logEvent:", err);
    }
  };

  useEffect(() => {
    fetchAds();
  }, [fetchAds]);

  useEffect(() => {
    logEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [eventLog]);

  return (
    <div style={{ padding: "1rem", fontFamily: "Arial, sans-serif" }}>
      <h2>Uncommon Media DOOH</h2>

      <select
        value={endpoint}
        onChange={(e) => setEndpoint(e.target.value)}
        style={{ width: "70%", padding: "0.5rem", marginBottom: "1rem" }}
      >
        <option value="">Select a Demo Option</option>
        {ENDPOINT_OPTIONS.map((option, idx) => (
          <option key={idx} value={option.url}>
            {option.label}
          </option>
        ))}
      </select>

      <button
        onClick={fetchAds}
        style={{ padding: "0.5rem 1rem", marginLeft: "1rem" }}
        disabled={!endpoint}
      >
        Load Ads
      </button>

      <div style={{ marginTop: "2rem" }}>
        <div
          style={{
            position: "relative",
            width: `${CONFIG.imageWidth * CONFIG.containerScale}px`,
            height: `${CONFIG.imageHeight * CONFIG.containerScale}px`,
            margin: "0 auto",
            marginBottom: "2rem",
          }}
        >
          {/* Left Screen */}
          <div
            style={{
              position: "absolute",
              top: `${CONFIG.leftScreenPosition.y * CONFIG.containerScale}px`,
              left: `${CONFIG.leftScreenPosition.x * CONFIG.containerScale}px`,
              width: `${CONFIG.screenWidth * CONFIG.containerScale}px`,
              height: `${CONFIG.screenHeight * CONFIG.containerScale}px`,
              overflow: "hidden",
              backgroundColor: "#000",
              zIndex: 1,
            }}
          >
            {videos.length > 0 ? (
              <VideoPlayer
                videoObjects={videos}
                onLog={logEvent}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transform: "scale(1.01)",
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
              />
            ) : (
              <div
                style={{
                  color: "white",
                  textAlign: "center",
                  paddingTop: "50%",
                }}
              >
                No videos
              </div>
            )}
          </div>

          {/* Right Screen */}
          <div
            style={{
              position: "absolute",
              top: `${CONFIG.rightScreenPosition.y * CONFIG.containerScale}px`,
              left: `${CONFIG.rightScreenPosition.x * CONFIG.containerScale}px`,
              width: `${CONFIG.screenWidth * CONFIG.containerScale}px`,
              height: `${CONFIG.screenHeight * CONFIG.containerScale}px`,
              overflow: "hidden",
              backgroundColor: "#000",
              zIndex: 1,
            }}
          >
            {videos.length > 0 ? (
              <VideoPlayer
                videoObjects={videos}
                onLog={logEvent}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transform: "scale(1.01)",
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
              />
            ) : (
              <div
                style={{
                  color: "white",
                  textAlign: "center",
                  paddingTop: "50%",
                }}
              >
                No videos
              </div>
            )}
          </div>

          {/* Frame */}
          <img
            src={PortraitImg}
            alt="TV display frame"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 2,
              pointerEvents: "none",
            }}
          />
        </div>

        {/* Event Log */}
        <div
          style={{
            backgroundColor: "#f5f5f5",
            borderRadius: "10px",
            padding: "1rem",
            height: "200px",
            overflowY: "auto",
            fontSize: "0.9rem",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <strong>Event Log:</strong>
          <ul
            style={{
              marginTop: "1rem",
              listStyleType: "none",
              paddingLeft: 0,
            }}
          >
            {eventLog.map((log, index) => (
              <li key={index} style={{ marginBottom: "0.5rem" }}>
                {log}
              </li>
            ))}
            <div ref={logEndRef} />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Portrait;
